import { useEffect, useState } from "react";

import { fetchReceiptObjectUrl, receiptContentPath, type ReimbursementReceipt } from "./reimbursementApi";

export function ReceiptThumb({
  scope,
  reimbursementId,
  receipt,
}: {
  scope: "personal" | "accounting";
  reimbursementId: string;
  receipt: ReimbursementReceipt;
}): JSX.Element {
  const [url, setUrl] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let active = true;
    let objectUrl: string | null = null;
    void fetchReceiptObjectUrl(receiptContentPath(scope, reimbursementId, receipt.id))
      .then((next) => {
        if (!active) {
          URL.revokeObjectURL(next);
          return;
        }
        objectUrl = next;
        setUrl(next);
      })
      .catch(() => {
        if (active) setFailed(true);
      });
    return () => {
      active = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [scope, reimbursementId, receipt.id]);

  if (failed) return <p className="text-sm text-slate-600">{receipt.filename}</p>;
  if (url == null) return <p className="text-sm text-slate-500">Loading receipt…</p>;
  if (receipt.mimeType === "application/pdf") {
    return (
      <a className="text-sm font-medium text-brand-700 underline" href={url} target="_blank" rel="noreferrer">
        Open {receipt.filename}
      </a>
    );
  }
  return <img src={url} alt={receipt.filename} className="max-h-72 w-full rounded-md border border-slate-200 object-contain" />;
}
